<template>
  <div class="main-container">
    <!-- Author: Siddhartha
      Date: 17/01/2020
    Issue Description: payroll Incometax children components-->
    <breadcrumb :list="breadcrumbList" />
   <under-construction></under-construction>

    <div class="margintop-32" />
    <tl-header type="h1">Organisation</tl-header>
    <div class="twoColumnGridDashboard marginbottom-5p">
      <div class="componentName" v-for="(nav, index) in navList" :key="index">
        <div class="c-title">{{nav.name}}</div>
        <!-- <div class="c-icon"><img src="@/assets/star_normal.svg" /></div> -->
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {},
  components: {},
  data() {
    return {
      breadcrumbList: [
        {
          name: "Organisation",
          url: `/dashboard/${this.$route.params.entity_index}/`
        },
        {
          name: "Employee Directory",
          url: ``
        }
      ],
      navList: [
        {
          name: "Add Leave Inputs",
          url: `/dashboard/${this.$route.params.entity_index}/`
        },
        {
          name: "Add New Employee",
          url: `/dashboard/${this.$route.params.entity_index}/`
        },
        {
          name: "Assign Manager",
          url: `/dashboard/${this.$route.params.entity_index}/`
        },
        {
          name: "Ess Management",
          url: `/dashboard/${this.$route.params.entity_index}/`
        },
        {
          name: "Reset Emp. Password",
          url: `/dashboard/${this.$route.params.entity_index}/`
        },
        {
          name: "Set Roles for Employee",
          url: `/dashboard/${this.$route.params.entity_index}/`
        },
        {
          name: "View Employee Details",
          url: `/dashboard/${this.$route.params.entity_index}/`
        },
        {
          name: "View Org Tree",
          url: `/dashboard/${this.$route.params.entity_index}/`
        },

      ]
    };
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins
.overlay {
  position: absolute;
}
</style>
